import { Store } from "lucide-react";

import AppleIcon from "../../../common/icons/AppleIcon";
import GoogleIcon from "../../../common/icons/GoogleIcon";
import OkastIcon from "../../../common/icons/OkastIcon";
import PaypalIcon from "../../../common/icons/PayPalIcon";
import StripeIcon from "../../../common/icons/StripeIcon";

import type { TFunction } from "i18next";
import type { ComponentType } from "react";

import type { PaymentIconProps, PaymentKind } from "./paymentIcons.types";

export const PAYMENT_ICONS: Record<
  PaymentKind,
  ComponentType<PaymentIconProps>
> = {
  okast: OkastIcon,
  stripe: StripeIcon,
  paypal: PaypalIcon,
  apple: AppleIcon,
  google: GoogleIcon,
  retailer: Store,
};

export function isPaymentKind(payment: string): payment is PaymentKind {
  return payment in PAYMENT_ICONS;
}

export function getPaymentLabel(
  payment: string,
  retailerName: string | undefined,
  t: TFunction,
): string {
  if (payment === "retailer") return retailerName ?? t("retailer");
  return String(t(payment, { defaultValue: payment }));
}
